let config = {
  messageOrigin: 'https://liber.marmaluot.com',
  baseUrl: 'https://liber.marmaluot.com/api/',
  //bugsUrl: 'https://liber.marmaluot.com/api/bugs/send.php',
  badges: {
    donator: {
      label: 'Donatore',
      iconName: 'FavoriteStarFill',
      href: 'https://qlcvea.it/tipjar'
    }
  },
  openSourceLicenses: [
    {
      name: '@fluentui/react',
      copyright: 'Copyright (c) Microsoft Corporation',
      licenseName: 'MIT',
      licenseUrl: 'https://github.com/microsoft/fluentui/blob/master/LICENSE'
    },
    {
      name: '@zxing/library',
      copyright: 'Copyright (c) Project Contributors',
      licenseName: 'Apache 2.0',
      licenseUrl: 'https://github.com/zxing-js/library/blob/master/LICENSE'
    },
    {
      name: 'identicon.js',
      copyright: 'Copyright (c) 2018, Stewart Lord',
      licenseName: 'BSD 2-clause',
      licenseUrl: 'https://github.com/stewartlord/identicon.js/blob/master/LICENSE'
    },
    {
      name: 'react',
      copyright: 'Copyright (c) Facebook, Inc. and its affiliates',
      licenseName: 'MIT',
      licenseUrl: 'https://github.com/facebook/react/blob/master/LICENSE'
    },
    {
      name: 'react-dom',
      copyright: 'Copyright (c) Facebook, Inc. and its affiliates',
      licenseName: 'MIT',
      licenseUrl: 'https://github.com/facebook/react/blob/master/LICENSE'
    },
    {
      name: 'react-scripts',
      copyright: 'Copyright (c) 2013-present, Facebook, Inc.',
      licenseName: 'MIT',
      licenseUrl: 'https://github.com/facebook/create-react-app/blob/master/packages/react-scripts/LICENSE'
    },
    {
      name: 'react-turnstile',
      copyright: 'Copyright (c) 2022-2023 LeoDeveloper',
      licenseName: 'MIT',
      licenseUrl: 'https://github.com/Le0Developer/react-turnstile/blob/main/LICENSE'
    },
  ],
  server: null,
  runtime: {
    userPos: null,
    users: {},
    addedScripts: {}
  }
};

export default config;